import { render, staticRenderFns } from "./restaurarModal.vue?vue&type=template&id=4a97bba0&scoped=true"
import script from "./restaurarModal.vue?vue&type=script&lang=js"
export * from "./restaurarModal.vue?vue&type=script&lang=js"
import style0 from "./restaurarModal.vue?vue&type=style&index=0&id=4a97bba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97bba0",
  null
  
)

export default component.exports